Placements.ENTRIES.expeditionIntroWindow = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,

    delayFromStart: "2 minutes",

    filter: function () {
        if (typeof ExpeditionIntroWindow === "undefined") {
            return false;
        }

        const page = ExpeditionIcon.getPriorityPage();
        if (!page || page.isCompleted() || !ExpeditionIntroWindow.hasIntro(page)) {
            return false;
        }

        const lastShown = page.getIntroWindowLastShown();
        return !lastShown || Date.now() - lastShown >= cleverapps.parseInterval("1 day");
    },

    action: function () {
        const page = ExpeditionIcon.getPriorityPage();
        page.setIntroWindowShown();

        cleverapps.focusManager.display({
            focus: "ExpeditionIntroWindowPlacement",
            action: function (f) {
                new ExpeditionIntroWindow(page);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};
